// extracted by mini-css-extract-plugin
module.exports = {"carouselLoading":"latest-cars_carouselLoading__VTfji","cardContainer":"latest-cars_cardContainer__syuiW","title":"latest-cars_title__dCT9x"};